
export const TableFields = {
    /** 姓名 */
    name: 'name',

    /** 证照号码 */
    cardNo: 'cardNo',

    /** 所得项目 */
    incomeProject: 'incomeProject',

    /** 所得期间起 */
    incomeStartTime: 'incomeStartTime',

    /** 所得期间止 */
    incomeEndTime: 'incomeEndTime',

    /** 收入(元) */
    incomeAmount: 'incomeAmount',

    /** 免税收入(元) */
    freeTaxAmount: 'freeTaxAmount',

    /** 实际捐赠额(元) */
    donationAmount: 'donationAmount',

    /** 捐赠方式 */
    donationType: 'donationType',

    /** 准予扣除的捐赠额(元) */
    allowDeductDonationAmount: 'allowDeductDonationAmount',

    /** 扣除及减除项目合计(元) */
    deductTotalAmount: 'deductTotalAmount',

    /** 应纳税所得额(元) */
    needPayTaxIncomeAmount: 'needPayTaxIncomeAmount',

    /** 税率 */
    taxRate: 'taxRate',

    /** 应纳税额(元) */
    needPayTaxAmount: 'needPayTaxAmount',

    /** 减免税额(元) */
    reductionTaxAmount: 'reductionTaxAmount',

    /** 应扣缴税额(元) */
    needDeductTaxAmount: 'needDeductTaxAmount',

    /** 已扣缴税额(元) */
    deductedPayTaxAmount: 'deductedPayTaxAmount',

    /** 应补（退）税额(元) */
    needReturnTaxAmount: 'needReturnTaxAmount',

    /** 会员身份 */
    memberIdentity: 'memberIdentity',

    /** 备注 */
    remark: 'remark',

    /** 新建时间 */
    createTime: 'createTime'
};
